import { type CSSProperties, memo } from 'react';
import { TooltipHeader } from '@/components/TooltipHeader';
import { formatValue, UnitOptions } from '@/core';
import { formatBucketBoundary } from './heat-map-model';
import { HoveredInfo } from './utils';

const ROW_STYLE: CSSProperties = { display: 'flex', justifyContent: 'space-between', gap: 8 };

export interface HeatMapExplorerTooltipContentProps {
  hoveredInfo: HoveredInfo;
  unit: UnitOptions;
}

/**
 * Body for the explorer heatmap follow-cursor tooltip (header + bucket/count/stat lines).
 */
export const HeatMapExplorerTooltipContent = memo(function HeatMapExplorerTooltipContent({
  hoveredInfo,
  unit,
}: HeatMapExplorerTooltipContentProps) {
  return (
    <>
      <TooltipHeader startDate={new Date(hoveredInfo.timestamp)} enablePinning={false} />
      <div style={{ paddingTop: 4, paddingBottom: 4, fontSize: '0.875rem' }}>
        {hoveredInfo.bucket && (
          <div style={ROW_STYLE}>
            <span>Bucket:</span>
            <span>
              {formatBucketBoundary(hoveredInfo.bucket.lower, unit)} to{' '}
              {formatBucketBoundary(hoveredInfo.bucket.upper, unit)}
            </span>
          </div>
        )}
        <div style={ROW_STYLE}>
          <span>Count:</span>
          <span>
            {hoveredInfo.value === null ? '--' : formatValue(hoveredInfo.value, { kind: 'Decimal', abbreviate: true })}
          </span>
        </div>
        {hoveredInfo.statLineValues.map((sl) => (
          <div key={sl.label} style={ROW_STYLE}>
            <span style={{ color: sl.color }}>{sl.label}:</span>
            <span style={{ color: sl.color }}>{formatBucketBoundary(sl.value, unit)}</span>
          </div>
        ))}
      </div>
    </>
  );
});
